
export default {
  props: {
    deal: {
      type: Object,
      required: true,
    },
    additionalText: {
      type: String,
      default: '',
    },
    hasPlus: {
      type: Boolean,
      default: () => ({}),
    },
    selectedPlan: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      label: '',
      link: '',
      disabled: false,
    };
  },
  watch: {
    additionalText() {
      this.createLabelData();
    },
  },
  created() {
    this.createLabelData();
  },
  methods: {
    onClickButton() {
      if (!this.disabled) {
        this.$emit('click-buy');
      }
    },

    createLabelData() {
      let label = `Buy now ${this.additionalText || ''}`;
      let link = '';
      let disabled = this.deal.buy_button.is_draft;

      if (this.deal.buy_button.is_last_call || this.deal.buy_button.is_early_access) {
        if (this.hasPlus) {
          label = 'Buy Now With Plus';
        } else {
          label = 'Join Plus now to buy';
          link = '/plus/';
        }
      } else if (this.deal.buy_button.is_coming_soon || this.deal.buy_button.is_ended) {
        label = 'Coming soon';
        disabled = true;
      } else if (this.deal.is_free || this.deal.buy_button.is_get_now) {
        label = this.deal.is_free ? 'Get now for FREE' : 'Get now';

        if (this.deal.clickthrough_url) {
          link = this.deal.clickthrough_url;
        }
      }

      this.label = label;
      this.link = link;
      this.disabled = disabled;
    },

    addToCart() {
      this.isDisabled = true;
      const data = new FormData();

      data.append('id', this.deal.id);

      if (this.selectedPlan) {
        data.append('plan_id', this.selectedPlan.id);
        data.append('quantity', this.selectedPlan.codes);
      } else if (this.deal.default_plan) {
        data.append('plan_id', this.deal.default_plan.id);
      }

      if (this.deal.is_free) {
        const quantity = (this.deal.use_licensing) ? 1 : this.deal.default_plan.codes;
        data.append('quantity', quantity);
      }

      const options = {
        headers: {
          'X-CSRFToken': this.$cookies.get('csrftoken'),
          'Content-Type': 'multipart/form-data',
        },
      };

      this.$axios.post('/cart/add/', data, options)
        .then(() => {
          if (window) {
            window.location = '/cart/';
          }
        })
        .catch(() => {
          this.$toastr.e('Something has gone wrong with this request. Please try again.');
          this.isDisabled = false;
        });
    },
  },
};
